import { Box, FormControlLabel, Switch } from '@mui/material';
import { bool, func, node, object } from 'prop-types';
import React, { useMemo } from 'react';

export const useConfigurationSectionSx = () =>
  useMemo(
    () => ({
      section: { width: '100%' },
      card: {
        width: '100%',
        border: 1,
        borderColor: 'divider',
        borderRadius: '12px',
        p: 2.5,
        bgcolor: 'background.paper',
      },
      sectionTitle: {
        fontSize: theme => theme.typography.pxToRem(16),
        fontWeight: 700,
        color: 'text.primary',
        mb: 0.75,
      },
      sectionHelper: {
        fontSize: theme => theme.typography.pxToRem(12.5),
        color: 'text.secondary',
        mb: 2,
        lineHeight: 1.45,
      },
      sectionDivider: {
        height: '1px',
        bgcolor: 'divider',
        my: 2.5,
      },
      fieldsStack: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
      },
      fieldLabel: {
        fontSize: theme => theme.typography.pxToRem(12.5),
        color: 'text.secondary',
        mb: 0.5,
      },
      step: {
        pt: 2.5,
        mt: 2.5,
        borderTop: 1,
        borderColor: 'divider',
      },
      toggleRow: {
        ml: 0,
        mr: 0,
        alignItems: 'center',
        gap: 1,
      },
      toggleLabel: {
        fontSize: theme => theme.typography.pxToRem(14),
        fontWeight: 500,
        color: 'text.primary',
        lineHeight: 1.4,
      },
    }),
    [],
  );

export const SettingsToggleRow = ({ label, checked, onChange, sx: sxProp }) => {
  const sx = useConfigurationSectionSx();
  return (
    <FormControlLabel
      sx={[sx.toggleRow, sxProp]}
      label={
        <Box component="span" sx={sx.toggleLabel}>
          {label}
        </Box>
      }
      control={<Switch size="small" checked={checked} onChange={onChange} />}
    />
  );
};

SettingsToggleRow.propTypes = {
  label: node.isRequired,
  checked: bool.isRequired,
  onChange: func.isRequired,
  sx: object,
};

export default useConfigurationSectionSx;
